import update from 'immutability-helper';
import fileApi from '../lib/api/file';
// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_METADTA = 'METADATA/LOAD_SUCCESS';
export const LOAD_METADATA = 'METADATA/LOADING';

export function receiveMetaData(metaData) {
    return {
        type: RECEIVE_METADTA,
        metaData,
    };
}

export function startLoading() {
    return {
        type: LOAD_METADATA,
    };
}

export function fetchMetaData(id) {
    return async (dispatch) => {
        dispatch(startLoading());
        const metaData = await fileApi.getMetaData(id);
        if (metaData) {
            dispatch(receiveMetaData(metaData));
        }
    };
}

export function fetchMetaDataIfNeeded(id) {
    return (dispatch, getState) => {
        if (!getState().file.elements[id]) {
            return dispatch(fetchMetaData(id));
        }
        return Promise.resolve();
    };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [RECEIVE_METADTA]: (state, action) => update(state, {
        elements: {
            [action.metaData.id]: {$set: action.metaData},
        },
        isLoading: {$set: false},
    }),
    [LOAD_METADATA]: (state) => update(state, {
        isLoading: {$set: true},
    }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
    elements: {},
    selected: null,
    isLoading: false,
};

export default function reducerFunction(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}
